(function () {
  const CONFIG = {
    allowedHost: 'eu.braingain.fit',

    allowedPathPrefixes: [
      '/en-de/',
      '/de/',
      '/de-de/',
      '/en-it/',
      '/it/',
      '/it-it/',
      '/en-fr/',
      '/fr-fr/',
      '/fr/'
    ],

    productPlaceholderSelector: '[data-klarna-payment-pill-product]',
    productLineId: 'klarna-payment-pill-product-line',
    cartLineId: 'klarna-payment-pill-cart-line',
    styleId: 'klarna-payment-pill-style',

    debug: false
  };

  function log() {
    if (CONFIG.debug) console.log('[Klarna Payment Pill]', ...arguments);
  }

  const path = window.location.pathname;

  const isTargetLocale =
    window.location.hostname === CONFIG.allowedHost &&
    CONFIG.allowedPathPrefixes.some(function (prefix) {
      return path.indexOf(prefix) === 0;
    });

  const isTargetPdp =
    isTargetLocale &&
    path.indexOf('/products/') !== -1;

  if (!isTargetLocale) return;

  let atcObserver = null;
  let cartObserver = null;
  let pageObserver = null;
  let lastObservedAtcButton = null;
  let lastObservedCartTotalNode = null;
  let renderQueued = false;

  function getLocale() {
    if (
      path.indexOf('/en-de/') === 0 ||
      path.indexOf('/en-it/') === 0 ||
      path.indexOf('/en-fr/') === 0
    ) {
      return 'en';
    }

    if (
      path.indexOf('/fr-fr/') === 0 ||
      path.indexOf('/fr/') === 0
    ) {
      return 'fr';
    }

    if (
      path.indexOf('/it/') === 0 ||
      path.indexOf('/it-it/') === 0
    ) {
      return 'it';
    }

    return 'de';
  }

  function injectStyles() {
    if (document.getElementById(CONFIG.styleId)) return;

    const style = document.createElement('style');
    style.id = CONFIG.styleId;
    style.textContent = `
      #${CONFIG.productLineId},
      #${CONFIG.cartLineId} {
        display: flex !important;
        align-items: center !important;
        gap: 8px !important;
        box-sizing: border-box !important;
        color: #171717 !important;
        background: #fff5fa !important;
        border: 2px solid #ffaad0 !important;
        border-radius: 999px !important;
        font-weight: 600 !important;
        line-height: 1.25 !important;
        text-align: center !important;
        clear: both !important;
      }

      #${CONFIG.productLineId} {
        width: fit-content !important;
        max-width: 100% !important;
        margin-top: 0 !important;
        margin-bottom: 15px !important;
        padding: 7px 15px !important;
        font-size: 13px !important;
      }

      #${CONFIG.cartLineId} {
        width: 100% !important;
        justify-content: center !important;
        margin: 8px 0 10px 0 !important;
        padding: 7px 12px !important;
        font-size: 13px !important;
      }

      #${CONFIG.productLineId} .klarna-payment-pill-badge,
      #${CONFIG.cartLineId} .klarna-payment-pill-badge {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        flex: 0 0 auto !important;
        background: #ff9ccc !important;
        color: #111 !important;
        border-radius: 7px !important;
        padding: 6px 12px !important;
        font-weight: 700 !important;
        line-height: 1 !important;
      }

      #${CONFIG.productLineId} .klarna-payment-pill-3x,
      #${CONFIG.cartLineId} .klarna-payment-pill-3x {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        flex: 0 0 auto !important;
        width: 28px !important;
        height: 28px !important;
        border-radius: 50% !important;
        background: #ffb3d5 !important;
        color: #111 !important;
        font-weight: 700 !important;
      }

      #${CONFIG.productLineId} .klarna-payment-pill-copy,
      #${CONFIG.cartLineId} .klarna-payment-pill-copy {
        white-space: nowrap !important;
      }

      @media (max-width: 480px) {
        #${CONFIG.productLineId} {
          width: 100% !important;
          font-size: 11px !important;
          padding: 6px 8px !important;
          gap: 4px !important;
          justify-content: flex-start !important;
        }

        #${CONFIG.cartLineId} {
          font-size: 11px !important;
          gap: 4px !important;
          padding: 7px 8px !important;
        }

        #${CONFIG.productLineId} .klarna-payment-pill-copy,
        #${CONFIG.cartLineId} .klarna-payment-pill-copy {
          white-space: normal !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
          text-align: left !important;
        }

        #${CONFIG.productLineId} .klarna-payment-pill-3x,
        #${CONFIG.cartLineId} .klarna-payment-pill-3x {
          width: 23px !important;
          height: 23px !important;
          min-width: 23px !important;
          font-size: 10px !important;
        }

        #${CONFIG.productLineId} .klarna-payment-pill-badge,
        #${CONFIG.cartLineId} .klarna-payment-pill-badge {
          padding: 4px 7px !important;
          font-size: 11px !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

function getProductPlaceholder() {
  let placeholder = document.querySelector(CONFIG.productPlaceholderSelector);

  if (placeholder) return placeholder;

  const priceBlock =
    document.querySelector('.product-description .product-info__block.product-price') ||
    document.querySelector('.product-description .product-price') ||
    document.querySelector('.product-info__block.product-price') ||
    document.querySelector('.product-price');

  if (!priceBlock) return null;

  placeholder = document.createElement('div');
  placeholder.id = 'klarna-payment-pill-product';
  placeholder.className = 'klarna-payment-pill-product-placeholder';
  placeholder.setAttribute('data-klarna-payment-pill-product', '');

  priceBlock.insertAdjacentElement('afterend', placeholder);

  return placeholder;
}

  function getProductPriceNode() {
    return (
      document.querySelector('.product-info__block.product-price .price__current') ||
      document.querySelector('.product-price .price__current') ||
      document.querySelector('.price__current')
    );
  }

  function getAtcButton() {
    return (
      document.querySelector('product-form button[name="add"]') ||
      document.querySelector('form.js-product-form-main button[name="add"]') ||
      document.querySelector('.product-info__add-button button[name="add"]') ||
      document.querySelector('button[name="add"]')
    );
  }

  function getCartDrawerFooterButtons() {
    return document.querySelector('.lcu__drawer__footer-buttons');
  }

  function getCartDrawerCheckoutGroup() {
    return (
      document.querySelector('.lcu__drawer__cta-group') ||
      (document.querySelector('#lcu__drawer-checkout') && document.querySelector('#lcu__drawer-checkout').parentElement)
    );
  }

  function getCartTotalNode() {
    return (
      document.querySelector('.lcu-summary-final-total') ||
      document.querySelector('.lcu__drawer__subtotal .lcu__product-price') ||
      document.querySelector('.lcu__drawer__footer .lcu__product-price')
    );
  }

  function extractEuroPrice(text) {
    if (!text) return null;

    const matches = text.match(/€\s?[\d\s.,]+|[\d\s.,]+\s?€/g);
    if (!matches || !matches.length) return null;

    const raw = matches[matches.length - 1]
      .replace(/\s/g, '')
      .replace('€', '')
      .replace('EUR', '');

    let normalised = raw;

    const hasComma = normalised.indexOf(',') !== -1;
    const hasDot = normalised.indexOf('.') !== -1;

    if (hasComma && hasDot) {
      if (normalised.lastIndexOf(',') > normalised.lastIndexOf('.')) {
        normalised = normalised.replace(/\./g, '').replace(',', '.');
      } else {
        normalised = normalised.replace(/,/g, '');
      }
    } else if (hasComma) {
      normalised = normalised.replace(',', '.');
    }

    const value = parseFloat(normalised);
    return Number.isFinite(value) ? value : null;
  }

  function getPdpLiveTotal() {
    const atcButton = getAtcButton();

    if (atcButton) {
      const atcTotal = extractEuroPrice(atcButton.textContent);

      if (atcTotal !== null) {
        return {
          amount: atcTotal,
          source: 'ATC button',
          node: atcButton
        };
      }
    }

    const priceNode = getProductPriceNode();

    if (priceNode) {
      const productPrice = extractEuroPrice(priceNode.textContent);

      if (productPrice !== null) {
        return {
          amount: productPrice,
          source: 'PDP price fallback',
          node: priceNode
        };
      }
    }

    return null;
  }

  function getCartLiveTotal() {
    const cartTotalNode = getCartTotalNode();

    if (!cartTotalNode) return null;

    const cartTotal = extractEuroPrice(cartTotalNode.textContent);

    if (cartTotal === null) return null;

    return {
      amount: cartTotal,
      source: 'Cart drawer total',
      node: cartTotalNode
    };
  }

  function calculateInstalment(total) {
    return Math.ceil((total * 100) / 3) / 100;
  }

  function formatEuro(amount) {
    const locale = getLocale();

    const localeCode =
      locale === 'it' ? 'it-IT' :
      locale === 'de' ? 'de-DE' :
      locale === 'fr' ? 'fr-FR' :
      'en-IE';

    return amount.toLocaleString(localeCode, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + '\u00A0€';
  }

  function getMessage(formattedAmount) {
    const locale = getLocale();

    if (locale === 'fr') {
      return `
        <span class="klarna-payment-pill-3x">3×</span>
        <span class="klarna-payment-pill-copy">Payez en 3 mensualités de ${formattedAmount} avec</span>
        <span class="klarna-payment-pill-badge">Klarna</span>
      `;
    }

    if (locale === 'it') {
      return `
        <span class="klarna-payment-pill-3x">3×</span>
        <span class="klarna-payment-pill-copy">Paga in 3 rate da ${formattedAmount} con</span>
        <span class="klarna-payment-pill-badge">Klarna</span>
      `;
    }

    if (locale === 'en') {
      return `
        <span class="klarna-payment-pill-3x">3×</span>
        <span class="klarna-payment-pill-copy">Pay in 3 monthly payments of ${formattedAmount} with</span>
        <span class="klarna-payment-pill-badge">Klarna</span>
      `;
    }

    return `
      <span class="klarna-payment-pill-3x">3×</span>
      <span class="klarna-payment-pill-copy">Bezahle in 3 Raten von ${formattedAmount} mit</span>
      <span class="klarna-payment-pill-badge">Klarna</span>
    `;
  }

  function renderProductLine() {
    if (!isTargetPdp) return;

    const placeholder = getProductPlaceholder();
    const liveTotal = getPdpLiveTotal();

    if (!placeholder || !liveTotal) return;

    injectStyles();

    let line = document.getElementById(CONFIG.productLineId);

    if (!line) {
      line = document.createElement('div');
      line.id = CONFIG.productLineId;
      line.setAttribute('aria-live', 'polite');
    }

    const instalmentAmount = calculateInstalment(liveTotal.amount);
    const formattedAmount = formatEuro(instalmentAmount);

    line.innerHTML = getMessage(formattedAmount);

    if (placeholder.firstElementChild !== line) {
      placeholder.innerHTML = '';
      placeholder.appendChild(line);
    }

    const atcButton = getAtcButton();
    if (atcButton) attachAtcObserver(atcButton);
  }

  function ensureCartLine() {
    const checkoutGroup = getCartDrawerCheckoutGroup();
    const footerButtons = getCartDrawerFooterButtons();

    if (!checkoutGroup || !footerButtons) return null;

    let line = document.getElementById(CONFIG.cartLineId);

    if (!line) {
      line = document.createElement('div');
      line.id = CONFIG.cartLineId;
      line.setAttribute('aria-live', 'polite');
    }

    if (line.nextElementSibling !== checkoutGroup) {
      checkoutGroup.insertAdjacentElement('beforebegin', line);
    }

    return line;
  }

  function renderCartLine() {
    const liveTotal = getCartLiveTotal();

    if (!liveTotal) return;

    injectStyles();

    const line = ensureCartLine();

    if (!line) return;

    const instalmentAmount = calculateInstalment(liveTotal.amount);
    const formattedAmount = formatEuro(instalmentAmount);

    line.innerHTML = getMessage(formattedAmount);

    attachCartTotalObserver(liveTotal.node);
  }

  function renderAll() {
    renderQueued = false;
    renderProductLine();
    renderCartLine();
  }

  function queueRender() {
    if (renderQueued) return;

    renderQueued = true;
    window.requestAnimationFrame(renderAll);
  }

  function attachAtcObserver(atcButton) {
    if (lastObservedAtcButton === atcButton && atcObserver) return;

    if (atcObserver) atcObserver.disconnect();

    lastObservedAtcButton = atcButton;

    atcObserver = new MutationObserver(queueRender);
    atcObserver.observe(atcButton, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function attachCartTotalObserver(cartTotalNode) {
    if (lastObservedCartTotalNode === cartTotalNode && cartObserver) return;

    if (cartObserver) cartObserver.disconnect();

    lastObservedCartTotalNode = cartTotalNode;

    cartObserver = new MutationObserver(queueRender);
    cartObserver.observe(cartTotalNode, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function attachPageObserver() {
    if (pageObserver || !document.body) return;

    pageObserver = new MutationObserver(queueRender);
    pageObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function attachInteractionListeners() {
    document.addEventListener('change', function () {
      setTimeout(queueRender, 0);
      setTimeout(queueRender, 100);
      setTimeout(queueRender, 300);
      setTimeout(queueRender, 800);
    });

    document.addEventListener('click', function () {
      setTimeout(queueRender, 0);
      setTimeout(queueRender, 100);
      setTimeout(queueRender, 300);
      setTimeout(queueRender, 800);
    });

    document.addEventListener('keyup', function () {
      setTimeout(queueRender, 100);
      setTimeout(queueRender, 400);
    });
  }

  function init() {
    queueRender();
    attachPageObserver();
    attachInteractionListeners();

    setTimeout(queueRender, 100);
    setTimeout(queueRender, 300);
    setTimeout(queueRender, 750);
    setTimeout(queueRender, 1500);
    setTimeout(queueRender, 3000);
    setTimeout(queueRender, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();